// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.post-comments-wrapper {
  color: var(--undp-jtf-btn-dark-color);
  padding: 2%;
  margin-left: 6px;
}
.post-comments-wrapper .add-comments-wrapper .comment-box {
  border-radius: 5px;
}
.post-comments-wrapper .add-comments-wrapper .comment-box:focus {
  border-color: var(--undp-jtf-btn-dark-color);
  box-shadow: none;
}
.post-comments-wrapper .add-comments-wrapper .error {
  color: red;
}
.post-comments-wrapper .add-comments-wrapper .error p {
  margin-top: 5px;
}
.post-comments-wrapper .add-comments-wrapper .btn-submit {
  color: #fff;
  background-color: var(--undp-jtf-btn-dark-color);
  font-family: "OpenSans-Bold";
  padding: 7px;
}
.post-comments-wrapper .add-comments-wrapper .btn-submit:hover {
  text-decoration: none;
  opacity: 0.9;
}

.add-comments-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-public-comment/post-public-comment.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;ACCA;EACE,qCAAA;EACA,WAAA;EACA,gBAAA;AAGF;AADI;EACE,kBAAA;AAGN;AAFM;EACE,4CAAA;EACA,gBAAA;AAIR;AADI;EACE,UAAA;AAGN;AAFM;EACE,eAAA;AAIR;AADI;EACE,WAAA;EACA,gDAAA;EACA,4BCnBc;EDoBd,YAAA;AAGN;AAFM;EACE,qBAAA;EACA,YAAA;AAIR;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AACF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../../scss/variables';\r\n.post-comments-wrapper {\r\n  color: var(--undp-jtf-btn-dark-color);\r\n  padding: 2%;\r\n  margin-left: 6px;\r\n  .add-comments-wrapper {\r\n    .comment-box {\r\n      border-radius: 5px;\r\n      &:focus {\r\n        border-color: var(--undp-jtf-btn-dark-color);\r\n        box-shadow: none;\r\n      }\r\n    }\r\n    .error {\r\n      color: red;\r\n      p {\r\n        margin-top: 5px;\r\n      }\r\n    }\r\n    .btn-submit {\r\n      color: #fff;\r\n      background-color: var(--undp-jtf-btn-dark-color);\r\n      font-family: $primary-font-bold;\r\n      padding: 7px;\r\n      &:hover {\r\n        text-decoration: none;\r\n        opacity: 0.9;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.add-comments-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n\r\n}","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
